<template>
    <div class="px-2">
        <div class="dataUploadTitle">Cargar datos Andrología</div>
        <div>
            <validation-observer ref="registerForm">
                <b-form class="auth-register-form mt-2" @submit.prevent="validationForm">
                    <b-form-group class="datePicker">
                        <h5 class="font-weight-bold ">
                            Fecha
                        </h5>
                        <flat-pickr v-model="andrology.date" class="form-control" />
                    </b-form-group>


                    <b-form-group label="Veterinario" label-for="veterinarian" class="veterian">
                        <validation-provider #default="{ errors }" name="veterinarian" rules="required">
                            <b-form-input id="veterinarian" v-model="andrology.veterinarian"
                                :state="errors.length > 0 ? false : null" name="veterinarian" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                    <b-form-group label="Seleccionar toro" label-for="selFemale"  class="selFemale" >

                        <v-select  id="selFemale" placeholder="Buscar y seleccionar Animal" v-model="animal_picker" :options="males" :values="males.value" label="text"  />
                    </b-form-group>
                    <b-form-group label="Condición" label-for="condition"  class="condition" >

                        <v-select  id="condition" v-model="condition_picker" :options="conditionOptions" :values="conditionOptions.value"  label="text"  />
                    </b-form-group>
                    <b-form-group class="detail" label="Detalle" label-for="detail">
                        <b-form-textarea rows="3" id="detail" v-model="andrology.details"></b-form-textarea> 

                    </b-form-group>
                </b-form>
            </validation-observer>
            <div class="additive">
            <div>Subir archivo o foto:</div>
            <div class="d-flex align-items-center ml-3 justify-content-center"><b-img src="@/assets/images/ganImage/uploadImage.png"/></div>
            <b-button
                type="submit"  v-on:click="insertAndrology"
                class="bg-primary dataButton mt-1 d-flex align-items-center justify-content-center ml-3"   
            
              >
               <div class="ml-5"> Incluir Evento </div> <div class="pl-3" style="color:#D7B92C"> <feather-icon icon="PlusIcon"  size="18" /></div>
              </b-button>
        </div></div>
        <ControlMenu />
    </div>
</template>



<script>
import ControlMenu from '@/components/ControlMenu.vue'
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BCol,BFormTextarea ,BFormGroup, BFormInput, BForm, BImg, BButton } from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
let apiURL='https://927d1d30.us-south.apigw.appdomain.cloud/ganapp/api/';
let self= this;
export default {
    components: {
        ControlMenu,
        flatPickr,
        BFormGroup,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BFormInput,
        BForm,
        required,
        vSelect,
        BImg,
        BFormTextarea,
        BButton,
    },
    data() {
        return {
            date: now,
            dateDefault: null,
            timePicker: null,
            datetime: null,
            multiDate: null,
            rangeDate: null,
            humanDate: null,
            disableDate: null,
            inlineDate: null,
            veterinarian: '',
            males: [],
            text:'',
            condition:null,
            animal_picker:0,
            condition_picker:0,
            conditionOptions:[],
            andrology:{
                animal_id:0,
                male_id:59,
                type:7,
                condition_id:0,
                date:now,
                veterinarian:"",
                details:"",
                status:1
            }
        }
    },

    methods: {

        async fetchCondition(config) {
            
            fetch(apiURL+"list/conditions", config)
            .then(response => response.json())
            .then(result => {
                this.conditionOptions = result.conditions.map(item => {return {text:item.name, value:item.id}})
            })
        },

        async fetchAnimals(config){
            let farmId= localStorage.getItem('currentFarm');
            fetch(apiURL+"list/animals?farm_id="+farmId+"&sex=0", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.animals);
                this.males = result.animals.map(item => {return {text:item.number+'-'+item.name,value:item.id}});
                console.log(this.animals);
            })
        },

        insertAndrology(){
            this.andrology.condition_id=this.condition_picker.value;
            this.andrology.animal_id=this.animal_picker.value;
            this.andrology.male_id=this.animal_picker.value;
            console.log(this.andrology);
            const token = localStorage.getItem("accessToken");
            const config = {headers: {"X-Authorization": `Bearer ${token}`}};
            this.$http.post("add/reproductive_records", this.andrology, config).then(() => {
                this.andrology={
                    animal_id:0,
                    male_id:59,
                    type:7,
                    condition_id:0,
                    date:null,
                    veterinarian:"",
                    details:"",
                    status:1
                }
            
                this.$swal({
                    title: 'Registro reproductivo',
                    text: 'Se insertó registro de andrologia de manera satisfactoria',
                    type: 'success',
                    icon:'success',
                    showCancelButton: false,
                    confirmButtonColor:'#5E8F23',
                    showCloseButton: true,
                    showLoaderOnConfirm: false  
                }).then(function(){
                    self.$router.replace({name:'basic-farm'});
                });
            }).catch(error => {
                console.log(error)
            });
        },

    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchCondition(config);
        this.fetchAnimals(config);
    }
}
</script>
    

<style lang="scss">
.dataUploadTitle {
    position: absolute;
    top: 1%;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}

.datePicker {
    position: absolute;
    top: 7%;
    width: 90%;
    background: #FFFFFF;
    border-radius: 5px;
}

.veterian {
    position: absolute;
    top: 17%;
    width: 90%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B;

}

.selFemale{
    position: absolute;
    top: 29%;
    width:90%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B; 
}

.condition {
     position: absolute;
    top: 37%;
    width:90%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B; 
}

.uploadImage {
    position: absolute;
    top: 60%;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #6E6B7B;
}
.detail {
    position: absolute;
    top: 45%;
    width:90%;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #6E6B7B;
}
.additive {
    position: absolute;
    top: 66%;
    font-weight: 400;
    font-size: 12px;
    color: #6E6B7B;
}
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/pages/page-auth.scss';
</style>